import { Injectable } from '@angular/core';
import { AbstractPolyShapeService } from '../abstract-polyshape.service';
import { LineHelper } from './line-helper';

@Injectable()
export class LineService extends AbstractPolyShapeService<LineHelper> {
  protected shapeStore = this.renderStore('lines');

  constructor() {
    super();
    this.setUpSubscriptions();
  }

  protected createHelper(index: number) {
    return new LineHelper(index);
  }
}
